import styled, {css} from "styled-components";

export const MinimumGamblingAgeDefaultBox = styled.div<{isShownInHeader: boolean, disableClick?: boolean}>`
    display: flex;
    flex-direction: row;
    align-items: center;
  
  ${props => !props.disableClick ? css`
    cursor: pointer;
    
    @media ${({theme}) => theme.mediaQuery.hover}{
      &:hover {
        opacity: 0.5;
      }
    }

    @media ${({theme}) => theme.mediaQuery.hoverNone}{
      &:active {
        opacity: 0.5;
      }
    }
    ` : null}
`;